import VASGraph from './VASGraph';

export default function NumericFeedbackItem({
  id,
  label,
  headingLevel = 4,
  graphProps,
  children = null,
}) {
  const Heading = `h${headingLevel}`;

  return (
    <section
      className="numeric-feedback-item"
      aria-labelledby={id}
      data-feedback-presentation-owner="numeric-feedback-item"
      data-responsive-layout="container"
    >
      <div className="numeric-feedback-item__layout">
        <Heading id={id} className="feedback-hierarchy__group-label numeric-feedback-item__label">
          {label}
        </Heading>
        <div className="numeric-feedback-item__graph">
          <VASGraph attributeName={label} {...graphProps} />
        </div>
        {children ? <div className="numeric-feedback-item__detail">{children}</div> : null}
      </div>
    </section>
  );
}
